import React from 'react'

import { Container } from '../../components/Bootstrap'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'
import TagCloud from '../../components/TagCloud'

import { bold } from '../../styles'

const data = [
  { text: 'services', size: 1.4 },
  { text: 'leadership', size: 1 },
  { text: 'Need', size: 2.4 },
  { text: 'disabilities', size: 1.1 },
  { text: 'funding', size: 2.2 },
  { text: 'support', size: 1.1 },
  { text: 'programs', size: 2 },
  { text: 'CILT', size: 1.6 },
]

const PartnerEight = () => (
  <Layout>
    <Hero>
      <h1>Question 8</h1>
      <p className={bold}>In your opinion, what are some critical issues or threats that the Centre for Independent Living in Toronto (CILT) might face in the next three years?</p>
    </Hero>
    <Container>
      <Navigation prev="/partners/7" next="/partners/9" />
      <TagCloud words={data} />
	  <Summary>The word cloud shows that the words most often used by respondents to the question of what critical issues and/or threats does CILT face are “Need” followed by “funding” "programs" and “CILT”.</Summary>
    </Container>
  </Layout>
)

export default PartnerEight
